module.exports = __webpack_public_path__ + "img/fi-rr-shield-plus.4c049de8.svg";